import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Standard admin-page header: a "back" link rendered as a ghost button, the
 * page title (optionally icon-prefixed), and optional right-aligned actions.
 *
 * The back control uses `<Button asChild><Link/></Button>` so it renders a
 * single `<a>` styled as a button — avoiding the invalid `<a><button>` nesting
 * produced by the old `<Link><Button/></Link>` pattern.
 */
const PageHeader = ({
  title,
  icon: Icon,
  backTo = '/dashboard',
  backLabel = 'Back',
  actions,
  titleTestId,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
    <div className="flex items-center gap-4">
      <Button asChild variant="ghost" data-testid="back-button">
        <Link to={backTo}>
          <ArrowLeft size={16} /> {backLabel}
        </Link>
      </Button>
      <h1
        className="font-serif text-3xl md:text-4xl font-bold text-primary flex items-center gap-2"
        data-testid={titleTestId}
      >
        {Icon ? <Icon size={28} /> : null}
        {title}
      </h1>
    </div>
    {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
  </div>
);

export default PageHeader;
